<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="rejectComment" />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <DatasetFields :dataset="dataset" :readonly="readonly" :editor-ready="loaded" @update="updateField" />
        <UserFormActions
          v-if="!readonly"
          :form_name_text="$t('forms.titles.' + formName)"
          :form_name="formName"
          :refForm="$refs.form"
          :saveform_trigger="false"
          object_type="dataset"
          :data="processData"
          :state="state"
          class="text-center mt-6"
          @change-state="changeState"
        />
        <div v-else class="text-center mt-6">
          <v-btn text @click="$router.go(-1)"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import changeState from "@/mixins/changeState";
import DatasetFields from "@/components/datasets/DatasetFields.vue";
import RejectCommentLayout from "@/components/layouts/RejectCommentLayout";
import UserFormActions from "@/components/action_buttons/UserFormActions";
import { createDefaultDataset, normalizeDataset, serializeDataset } from "@/utils/dataset";

export default {
  name: "DatasetFormEditor",
  components: { DatasetFields, RejectCommentLayout, UserFormActions },
  mixins: [changeState],
  props: {
    formName: { type: String, required: true },
    modification: { type: Boolean, default: false }
  },
  data: () => ({
    dataset: createDefaultDataset(), objectId: null, state: "", rejectComment: "", loaded: false
  }),
  computed: {
    readonly() { return Boolean(this.$route.meta.readOnly); },
    isStoredForm() { return this.$route.params.id > -1 && !this.$route.meta.update; },
    processData() {
      return {
        title: this.dataset.title || "",
        object_type: "dataset",
        form_name: this.formName,
        object_id: this.objectId,
        data: { user: { dataset: serializeDataset(this.dataset) } }
      };
    }
  },
  created() {
    if (this.isStoredForm) this.getStoredForm();
    else if (this.modification) this.getDataset();
    else this.loaded = true;
  },
  methods: {
    updateField(field, value) { this.$set(this.dataset, field, value); },
    getStoredForm() {
      axios.get(`${this.$store.state.endpoint}/user/moderatedOperations/dataset/${this.$route.params.id}`)
        .then(response => {
          this.modOp_id = response.data.id;
          this.objectId = response.data.object_id;
          this.dataset = normalizeDataset(response.data.data.user.dataset);
          this.state = response.data.state;
          this.rejectComment = response.data.reject_comment || "";
        }).catch(error => console.error(error)).finally(() => { this.loaded = true; });
    },
    getDataset() {
      axios.get(`${this.$store.state.endpoint}/user/dataset/${this.$route.params.id}`)
        .then(response => {
          this.dataset = normalizeDataset(response.data);
          this.objectId = response.data.id;
        }).catch(error => console.error(error)).finally(() => { this.loaded = true; });
    }
  }
};
</script>
